import React, {useState,useEffect} from "react";
import {MDBListGroupItem, MDBInput, MDBInputGroup, MDBBtn, MDBListGroup, MDBNavLink,
    MDBContainer, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter} from "mdbreact";
import firebase from "../../Config/firebase";
import {timeStampToPostString} from "../../Utils/converter";
import classes from './ReviewHistory.module.css'

const db = firebase.firestore()

const ReviewHistory = (props) =>{
    const [ history,setHistory]=useState([])
    const [ isLoaded,setIsLoaded]=useState(false)

    const [isOpen, setIsOpen] = useState(false)

    useEffect(()=>{
        if (!isOpen && props.isOpen) {
            getReviewHistory()
            setIsLoaded(true)
            setIsOpen(true)

        }
    },[props.isOpen])

    const getReviewHistory = ()=> {
        db.collection("Post").doc(props.postID)
        .collection("Review").doc(props.reviewID)
        .collection('History')
        .orderBy('createDate', 'desc')
        .get()
        .then(docs => {
            if (!docs.empty) {
                let allHistory = []
                docs.forEach(function (doc) {
                    const History = {
                        id: doc.id,
                        ...doc.data()
                    }
                    allHistory.push(History)
                })
                setHistory(allHistory)
            }
        })
    }


    return(
        <MDBModal isOpen={isOpen} className={classes.Modal}>
            <MDBModalHeader>歷史回應</MDBModalHeader>
            <MDBModalBody>
                {
                    isLoaded?
                        history.map((History,index)=>{
                            return(
                                <MDBListGroup>
                                    <MDBListGroupItem>
                                        <div>
                                            {History.reviewContent}
                                        </div>
                                        <div>
                                            {timeStampToPostString(History.createDate)}
                                        </div>
                                    </MDBListGroupItem>
                                </MDBListGroup>
                            )
                        })
                        :''
                }
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => {
                    setIsOpen(false)}}>Close</MDBBtn>
            </MDBModalFooter>
        </MDBModal>
    )

}
export default ReviewHistory